import { __assign, __extends } from "tslib";
import { v4 as uuidV4 } from 'uuid';
import { API_HOST } from '../../config';
import { WEB_SDK_SOURCE } from '../../constants';
import { TrustFrameError } from '../../errors';
import EventEmitter from '../../lib/event-emitter';
import { getOrigin } from '../../lib/url';
import { sizeToInt } from '../../lib/utils';
import { FrameMessageType, FrameOutMessageType } from '../../types';
import { isAllowedFrameAttribute } from '../../constant';
import { getAllow } from '../../utils/allow';
import { applePay } from '../apple-pay';
import { listenPayment } from '../listen-payment';
var PaymentFrame = (function (_super) {
    __extends(PaymentFrame, _super);
    function PaymentFrame(url, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.apiHost, apiHost = _c === void 0 ? API_HOST : _c, _d = _b.canUseApplePay, canUseApplePay = _d === void 0 ? false : _d, onDomMount = _b.onDomMount, onDomUnmount = _b.onDomUnmount;
        var _this = _super.call(this) || this;
        _this.apiHost = apiHost;
        _this.canUseApplePay = canUseApplePay;
        _this.frameUrl = url;
        _this.frameOrigin = getOrigin(url);
        _this.onDomMount = onDomMount;
        _this.onDomUnmount = onDomUnmount;
        _this.onPaymentMessage = _this.onPaymentMessage.bind(_this);
        return _this;
    }
    Object.defineProperty(PaymentFrame.prototype, "isConnected", {
        get: function () {
            return this.frame && this.frame.isConnected;
        },
        enumerable: false,
        configurable: true
    });
    PaymentFrame.prototype.mount = function (parent, attrs) {
        var _this = this;
        var parentElement = typeof parent === 'string' ? document.querySelector(parent) : parent;
        if (!(parentElement instanceof HTMLElement)) {
            throw new TrustFrameError("Invalid mount target \"".concat(parent, "\""));
        }
        if (this.frame) {
            throw new TrustFrameError('Frame already mounted');
        }
        this.frame = this.createFrame(attrs);
        var unListenForm = listenPayment(this.onPaymentMessage);
        var unListenApplePay = this.canUseApplePay
            ? applePay({
                apiHost: this.apiHost,
                onSendResponse: function (m) {
                    _this.send(m);
                }
            })
            : undefined;
        this.unlistenFrame = function () {
            unListenForm();
            unListenApplePay === null || unListenApplePay === void 0 ? void 0 : unListenApplePay();
        };
        parentElement.appendChild(this.frame);
        if (this.onDomMount) {
            this.onDomMount(this.frame);
        }
    };
    PaymentFrame.prototype.unmount = function () {
        var _a;
        if (this.unlistenFrame) {
            this.unlistenFrame();
        }
        if ((_a = this.frame) === null || _a === void 0 ? void 0 : _a.parentNode) {
            this.frame.parentNode.removeChild(this.frame);
            if (this.onDomUnmount) {
                this.onDomUnmount();
            }
        }
    };
    PaymentFrame.prototype.send = function (data) {
        var _a;
        if (this.frame) {
            (_a = this.frame.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(data, this.frameOrigin);
        }
    };
    PaymentFrame.prototype.callAction = function (action) {
        var _this = this;
        return new Promise(function (resolve) {
            var actionId = uuidV4();
            var responseWatcher = function (message) {
                var _a;
                if (((_a = message === null || message === void 0 ? void 0 : message.data) === null || _a === void 0 ? void 0 : _a.actionId) !== actionId) {
                    return;
                }
                _this.off(FrameMessageType.callActionResponse, responseWatcher);
                resolve(message.data.actionData);
            };
            _this.on(FrameMessageType.callActionResponse, responseWatcher);
            _this.send({
                source: WEB_SDK_SOURCE,
                type: FrameOutMessageType.callAction,
                data: __assign({ actionId: actionId }, action)
            });
        });
    };
    PaymentFrame.prototype.createAttributes = function (frame, attrs) {
        if (attrs) {
            Object.keys(attrs).forEach(function (name) {
                if (isAllowedFrameAttribute(name)) {
                    frame[name] = attrs[name];
                }
            });
        }
    };
    PaymentFrame.prototype.createFrame = function (attrs) {
        var frame = document.createElement('iframe');
        var allowAttr = getAllow(attrs === null || attrs === void 0 ? void 0 : attrs.allow);
        var frameAttrs = __assign(__assign({}, attrs), { allow: allowAttr });
        this.createAttributes(frame, frameAttrs);
        frame.src = this.frameUrl;
        return frame;
    };
    PaymentFrame.prototype.resizeFrame = function (message) {
        var width = sizeToInt(message.size.width);
        var height = sizeToInt(message.size.height);
        if (this.frame && width) {
            this.frame.width = "".concat(width);
        }
        if (this.frame && height) {
            this.frame.height = "".concat(height);
        }
    };
    PaymentFrame.prototype.onPaymentMessage = function (message) {
        if (message.type === FrameMessageType.resize) {
            this.resizeFrame(message);
        }
        this.emit(message.type, message);
    };
    return PaymentFrame;
}(EventEmitter));
export { PaymentFrame };
